export default __webpack_public_path__ + "assets/bedrooms.58c45485.svg";